export default __webpack_public_path__ + "static/media/charter-banner.f60c48d9.webp";